import ViewStreamIcon from '@material-ui/icons/ViewStream';
import ViewColumnIcon from '@material-ui/icons/ViewColumn';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import FilterListIcon from '@material-ui/icons/FilterList';
import HistoryIcon from '@material-ui/icons/History';
import SearchIcon from '@material-ui/icons/Search';
import CategoryIcon from '@material-ui/icons/Category';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import SortIcon from '@material-ui/icons/Sort';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

/**
 * Component icons mapping
 */
export const COMPONENT_ICONS = {
  // Containers
  stack: ViewStreamIcon,
  columns: ViewColumnIcon,
  header: ViewStreamIcon,
  footer: ViewStreamIcon,
  contentBody: ViewStreamIcon,
  floating: ViewStreamIcon,
  section: ViewStreamIcon,

  // Blocks
  products: ShoppingCartIcon,
  facets: FilterListIcon,
  history: HistoryIcon,
  suggestions: SearchIcon,
  catSuggestions: CategoryIcon,
  pills: LocalOfferIcon,
  sort: SortIcon,
  pagination: NavigateNextIcon,
  filtersButton: FilterListIcon,
  fallbackWarning: CategoryIcon,
  noResults: CategoryIcon,
  didYouMean: SearchIcon,
  text: CategoryIcon,
};

/**
 * Component labels mapping
 */
export const getComponentLabel = (type, t) => {
  const labels = {
    // Containers
    stack: t('searchInterface.canvas.stackContainer'),
    columns: t('searchInterface.canvas.columnsLayout'),
    header: t('ui.editor.canvas.canvasBuilder.constants.header'),
    footer: t('searchInterface.canvas.footer'),
    contentBody: t('searchInterface.canvas.contentBody'),
    floating: t('searchInterface.canvas.floating'),
    section: t('searchInterface.canvas.section'),

    // Blocks
    products: t('searchInterface.canvas.productsList'),
    facets: t('searchInterface.canvas.facets'),
    history: t('searchInterface.canvas.history'),
    suggestions: t('searchInterface.canvas.suggestions'),
    catSuggestions: t('searchInterface.canvas.categorySuggestions'),
    pills: t('searchInterface.canvas.pills'),
    sort: t('searchInterface.canvas.sort'),
    pagination: t('searchInterface.canvas.pagination'),
    filtersButton: t('searchInterface.canvas.filtersButton'),
    fallbackWarning: t('searchInterface.canvas.fallbackWarning'),
    noResults: t('searchInterface.canvas.noResults'),
    didYouMean: t('searchInterface.canvas.didYouMean'),
    text: t('searchInterface.canvas.text'),
  };
  return labels[type] || type;
};

/**
 * Generate unique ID for nodes
 */
export const generateId = (type) => `${type}_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
